var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4838 7.11021C6.99481 7.59817 6.99481 8.40183 6.4838 8.88978L6.41397 8.95641C5.10413 10.2066 4.09232 11.1719 3.78731 13.1953C3.6794 13.9087 4.29068 14.5 5.02637 14.5H7.9999H10.9735C11.7092 14.5 12.3205 13.9087 12.2126 13.1953C11.9076 11.1719 10.8957 10.2066 9.5859 8.95641L9.51609 8.88978C9.00506 8.40183 9.00506 7.59817 9.51609 7.11021L9.5859 7.04359C10.8957 5.79348 11.9076 4.82816 12.2126 2.80476C12.3205 2.09129 11.7092 1.5 10.9735 1.5H7.9999H5.02637C4.29068 1.5 3.6794 2.09129 3.78731 2.80476C4.09232 4.82816 5.10413 5.79348 6.41397 7.04359L6.4838 7.11021ZM6.92779 6.00676L6.92305 6.00271C5.92488 5.11015 5.1822 4.44571 5.08541 2.80238C5.07937 2.70129 5.12317 2.61052 5.19459 2.55038C5.25013 2.50333 5.3228 2.475 5.40215 2.475H7.9999H10.5974C10.691 2.475 10.7755 2.51451 10.8335 2.5776C10.8878 2.63631 10.9192 2.7155 10.9141 2.80238C10.8173 4.44571 10.0746 5.11015 9.07682 6.00271C8.81273 6.23877 8.53089 6.49084 8.23858 6.78118C8.10689 6.91203 7.89265 6.91203 7.76096 6.78118C7.47022 6.49251 7.19 6.24162 6.92779 6.00676Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerm);
export default __webpack_public_path__ + "static/media/term.5c265ec3ce3c61cd633759b2e1de11f2.svg";
export { ForwardRef as ReactComponent };